<template>
	<tr :class="rootClass">
		<td scope="row" class="td_board" v-if="!isSearch">
			<div class="board_state"></div>
		</td>

		<td scope="row" class="td_title" :colspan="colspan">
			<strong class="tit_board">
				{{ message }}
				<span class="box_regulation">
					<a :href="blindArticleUrl" class="link_regulation" v-if="showBlindArticle">원문보기</a>
					<a :href="restrictionUrl" class="link_regulation" target="_blank">규제관련 안내</a>
				</span>
			</strong>
		</td>
	</tr>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import {RESTRICTION_URL, RESTRICTION_MESSAGE} from '../../constants.mjs';

export default {
	props: {
		dataid: {type: [String, Number]},

		vldstatus: {type: String},
		bbsdepth: {type: String},

		userid: {type: String, default: ''},
	},
	computed: {
		...mapState({
			currentDataid: 'dataid',
			myUserId: 'userId'
		}),
		...mapGetters(['isSearch']),
		rootClass() {
			return {
				article_mine: this.isMine,
				current_board: this.isCurrentArticle
			};
		},
		isMine() {
			return this.userid === this.myUserId;
		},
		isCurrentArticle() {
			return this.dataid.toString() === this.currentDataid;
		},
		colspan() {
			return this.isSearch ? 4 : 5;
		},
		message() {
			if (RESTRICTION_MESSAGE[this.vldstatus]) {
				return RESTRICTION_MESSAGE[this.vldstatus];
			}

			return RESTRICTION_MESSAGE.DEFAULT;
		},
		showBlindArticle() {
			return this.isMine || ['7PVMl', '7PVMY', '70Wum'].includes(this.myUserId);
		},
		blindArticleUrl() {
			return `/_c21_/blind_bbs_read?grpid=${this.grpid}&fldid=${this.fldid}&contentval=${this.bbsdepth}`;
		},
		restrictionUrl() {
			if (RESTRICTION_URL[this.vldstatus]) {
				return RESTRICTION_URL[this.vldstatus];
			}

			return RESTRICTION_URL.DEFAULT;
		}
	}
}
</script>
